import _ from 'lodash';
import numeral from 'numeral';
import { SearchDataItem } from '../../../../../logic/domains/search.domain';
import formatAsUpperFirst from '../../../../../logic/functions/common/formatAsUpperFirst';

export const getFormattedCurrencyForCSV = (amount: Number) =>
	`"${numeral(amount).format('$0,0.00')}"`;

export const isMembersItem = (item: SearchDataItem) => {
	if (item.type === 'plan') {
		return item.memberCount || 0;
	}
	return null;
};

export const shouldDisplayPremium = (item: SearchDataItem) => {
	if (item.type === 'plan') {
		return null;
	} else {
		return getFormattedCurrencyForCSV(
			item.premium ? _.toNumber(item.premium) : 0
		);
	}
};

export const formatWithQuotes = (value: string | undefined) => {
	return value ? `"${value}"` : '';
};

export const getSearchResultList = (
	data: SearchDataItem[],
	filterBy: 'plan' | 'client' | 'group' | undefined
) => {
	let filteredData = data;
	if (filterBy) {
		filteredData = _.filter(
			data,
			(item: SearchDataItem) => item.type === filterBy
		);
	}
	const searchList = _(filteredData)
		.map(item => {
			return [
				formatWithQuotes(formatAsUpperFirst(item.name)),
				formatWithQuotes(item.id),
				formatWithQuotes(item.type === 'client' ? 'individual' : item.type),
				formatWithQuotes(item.address),
				shouldDisplayPremium(item),
				getFormattedCurrencyForCSV(item.balance ? item.balance : 0),
			];
		})
		.value();

	return searchList;
};
